<template>
  <div>
    <v-container fluid>
    <v-snackbar
    color="error"
    top
    multiLine
    v-model="errorBar"
    :timeout="3000"
    >
      Please Fill All Fields !
      <v-btn
        dark
        icon
        @click="errorBar = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-snackbar
    color="warning"
    top
    multiLine
    v-model="warningBar"
    :timeout="3000"
    >
      Sorry, we couldn't find any flights that match your search
      <v-btn
        dark
        icon
        @click="warningBar = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <!-- radio group  -->
    <v-form ref="form">
      <v-row no-gutters>
        <v-col cols="12" md="3">
          <v-select
            v-model="flightType"
            :items="types"
            :label="flightType.text"
            outlined
            item-text="text"
            item-value="value"
            class="borderSl"
            return-object
          ></v-select>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-n4">
        <v-col cols="12" :md="flightType.value==='multi'?4:3" class="ma-1 ma-md-0">
           <cities type="Departure"></cities>
        </v-col>
        <v-col cols="12" :md="flightType.value==='multi'?4:3" class="cont ma-1 ma-md-0">
           <cities type="Arrival" @setSecondDeparture="setSecondDeparture"></cities>
            <div class="d-none  indigo d-md-flex flex-column arrowsIcon">
            <v-icon color="white" size="15">
              mdi-arrow-left-thin
            </v-icon>
            <v-icon color="white" class="mt-n2" size="15">
              mdi-arrow-right-thin
            </v-icon>
          </div>
        </v-col>
        <v-col cols="12" :md="flightType.value==='one'?'2' : flightType.value === 'multi'? '4' :'3' " class="ma-1 ma-md-0">
           <picker  type="Departure Date" date-placeholder="Departure Date" ></picker>
        </v-col>
        <v-col v-if="flightType.value === 'round'" cols="12" md="3" class="ma-1 ma-md-0">
          <picker  type="Return Date" date-placeholder="return Date" ></picker>
        </v-col>
         <v-col v-if="flightType.value === 'one'" cols="12" md="3" class="ma-1 ma-md-0">
           <passengers/>
        </v-col>
        <v-col v-if="flightType.value === 'one'" cols="12" md="1" class="d-none d-md-block ma-1 ma-md-0">
           <v-btn
             tile
             class="white--text mt-1 search"
             block
             color="indigo"
             height="56"
             :loading="loading"
             @click="submit"
            >
              search
            </v-btn>
          </v-col>
      </v-row>
       <!-- second datepickers component for multi -->
        <v-row no-gutters v-if="flightType.value === 'multi'" class="ma-1 ma-md-0">
         <v-col cols="12" md="4">
           <cities type="Second Departure" :getSecondDeparture="secondDeparture"></cities>
         </v-col>
          <v-col cols="12" md="4" class="cont ma-1 ma-md-0">
            <cities type="Second Arrival" @setThirdDeparture="setThirdDeparture"></cities>
            <div class="d-none  indigo d-md-flex flex-column arrowsIcon">
            <v-icon color="white" size="15">
              mdi-arrow-left-thin
            </v-icon>
            <v-icon color="white" class="mt-n2" size="15">
              mdi-arrow-right-thin
            </v-icon>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="ma-1 ma-md-0">
            <picker type="Second Departure Date"></picker>
          </v-col>
        </v-row>
      <!-- third autocomplete components for multi -->
        <v-row no-gutters v-if="flightType.value === 'multi' && segments">
          <v-col cols="12" md="4" class="ma-1 ma-md-0">
            <cities type="Third Departure" :getThirdDeparture="thirdDeparture"></cities>
          </v-col>
          <v-col cols="12" md="4" class="cont ma-1 ma-md-0">
            <cities type="Third Arrival"></cities>
             <div class="d-none  indigo d-md-flex flex-column arrowsIcon">
            <v-icon color="white" size="15">
              mdi-arrow-left-thin
            </v-icon>
            <v-icon color="white" class="mt-n2" size="15">
              mdi-arrow-right-thin
            </v-icon>
          </div>
          </v-col>
          <v-col cols="12" md="4" class="ma-1 ma-md-0">
             <picker type="Third Departure Date"></picker>
          </v-col>
        </v-row>
      <!-- third datepickers component for multi -->
        <v-row no-gutters v-if="flightType.value === 'multi' && segments" class="d-flex d-md-none">
          <v-col cols="12" class="py-0 my-0 ma-1 ma-md-0">
            <picker type="Third Departure Date"></picker>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" class="ma-1 ma-md-0">
            <v-btn block color="indigo" v-if="flightType.value === 'multi' && !segments"  @click="segments = !segments" class="white--text">
            <v-icon left color="white">mdi-plus-circle</v-icon>
             Add a segment
            </v-btn>
          </v-col>
         </v-row>
      <!-- button for removing a travel segment -->
        <v-row no-gutters>
          <v-col cols="12" class="ma-1 ma-md-0">
            <v-btn block color="grey" v-if="flightType.value === 'multi' && segments" @click="removeSegment" class="white--text">
              <v-icon left color="white">mdi-close-circle</v-icon>
              Remove this segment
            </v-btn>
          </v-col>
        </v-row>
      <v-row no-gutters>
        <v-col cols="12" md="3" class="ma-1 ma-md-0">
          <cities type="airline"></cities>
        </v-col>
         <v-col v-if="flightType.value !== 'one'" cols="12" md="3" class="ma-1 ma-md-0">
           <passengers/>
        </v-col>
        <v-col cols="12" md="3" class="ma-1 ma-md-0">
          <v-switch
          v-model="directFlights"
          inset
          color="indigo"
          >
            <template v-slot:label>
              <span class="font-weight-medium" style="letter-spacing: 1.5px;">Direct Flights</span>
            </template>
          </v-switch>
        </v-col>
        <v-col v-if="flightType.value !== 'one' || isSmAndDown" cols="12" md="3" class="ma-1 ma-md-0">
           <v-btn
             tile
             class="white--text mt-1 search"
             block
             color="indigo"
             height="56"
             :loading="loading"
             @click="submit"
            >
              search
            </v-btn>
        </v-col>
      </v-row>
    </v-form>
    </v-container>
  </div>
</template>

<script>
import cities from './citiesAutocomplete.vue'
import picker from './datePicker.vue'
import passengers from './passengersInfo'
import { searchFlights, headersNoAuth } from '../links'

export default {
  components: {
    cities,
    picker,
    passengers
  },
  data () {
    return {
      flightType: { text: 'Round Trip', value: 'round' },
      today: new Date().toISOString().substr(0, 10),
      segments: true,
      errorBar: false,
      warningBar: false,
      loading: false,
      secondDeparture: null,
      thirdDeparture: null,
      directFlights: false,
      types: [
        { text: 'Round Trip', value: 'round' },
        { text: 'One-way Trip', value: 'one' },
        { text: 'Multi City Trip', value: 'multi' }
      ]
    }
  },
  computed: {
    tomorrow () {
      const tomorrow = new Date(this.today)
      tomorrow.setDate(tomorrow.getDate() + 1)
      return tomorrow.toISOString().slice(0, 10)
    },
    isSmAndDown () {
      return this.$vuetify.breakpoint.smAndDown
    }
  },
  methods: {
    setSecondDeparture (value) {
      this.secondDeparture = value
    },
    setThirdDeparture (value) {
      this.thirdDeparture = value
    },
    removeSegment () {
      this.segments = !this.segments
      this.$store.dispatch('removeSegment')
    },
    submit () {
      this.$emit('startLoad')
      const searchStore = this.$store.state
      const searchParameters = {
        tripType: this.flightType.value
      }
      this.$store.dispatch('setType', this.flightType.value)
      let data = ''
      let string = ''
      if (new Date(searchStore.flightDates.departureDates[0]).getTime() > new Date().getTime()) {
        if (new Date(searchStore.flightDates.departureDates[0]).getTime() < new Date(searchStore.flightDates.arrivalDate).getTime() || this.flightType.value !== 'round') {
          switch (this.flightType.value) {
            case 'round':
              if (searchStore.airports.departureAirports[0] &&
                  searchStore.airports.arrivalAirports[0] &&
                  searchStore.flightDates.departureDates[0] &&
                  searchStore.flightDates.arrivalDate
              ) {
                searchParameters.origin = searchStore.airports.departureAirports[0].Code
                searchParameters.destination = searchStore.airports.arrivalAirports[0].Code
                searchParameters.originType = searchStore.airports.departureAirports[0].Type
                searchParameters.destinationType = searchStore.airports.arrivalAirports[0].Type
                searchParameters.departureDate = searchStore.flightDates.departureDates[0]
                searchParameters.arrivalDate = searchStore.flightDates.arrivalDate
                searchParameters.classType = searchStore.passengers.classType
                searchParameters.adults = searchStore.passengers.adults
                searchParameters.children = searchStore.passengers.children
                searchParameters.infants = searchStore.passengers.infants
                searchParameters.directFlights = this.directFlights ? 1 : 0
                // searchParameters.exactAirline = 'EY'
                if (searchStore.preferredAirline) searchParameters.preferredAirline = searchStore.preferredAirline.code
                data = Object.entries(searchParameters).map(
                  ([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`
                ).join('&')
                // console.log('round', data)
                this.request(data)
              } else {
                this.errorBar = true
              }
              break
            case 'one':
              if (searchStore.airports.departureAirports[0] &&
                  searchStore.airports.arrivalAirports[0] &&
                  searchStore.flightDates.departureDates[0]
              ) {
                searchParameters.origin = searchStore.airports.departureAirports[0].Code
                searchParameters.destination = searchStore.airports.arrivalAirports[0].Code
                searchParameters.originType = searchStore.airports.departureAirports[0].Type
                searchParameters.destinationType = searchStore.airports.arrivalAirports[0].Type
                searchParameters.departureDate = searchStore.flightDates.departureDates[0]
                searchParameters.classType = searchStore.passengers.classType
                searchParameters.adults = searchStore.passengers.adults
                searchParameters.children = searchStore.passengers.children
                searchParameters.infants = searchStore.passengers.infants
                searchParameters.directFlights = this.directFlights ? 1 : 0
                // searchParameters.exactAirline = 'EY'
                if (searchStore.preferredAirline) searchParameters.preferredAirline = searchStore.preferredAirline.code
                data = Object.entries(searchParameters).map(
                  ([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`
                ).join('&')
                // console.log(data)
                this.request(data)
              } else {
                this.errorBar = true
              }
              break
            case 'multi':
              if (searchStore.airports.departureAirports[0] &&
                  searchStore.airports.departureAirports[1] &&
                  searchStore.airports.arrivalAirports[0] &&
                  searchStore.airports.arrivalAirports[1] &&
                  searchStore.flightDates.departureDates[0] &&
                  searchStore.flightDates.departureDates[1]
              ) {
                searchParameters.origin = searchStore.airports.departureAirports
                searchParameters.destination = searchStore.airports.arrivalAirports
                searchParameters.departureDate = searchStore.flightDates.departureDates
                searchParameters.classType = searchStore.passengers.classType
                searchParameters.adults = searchStore.passengers.adults
                searchParameters.children = searchStore.passengers.children
                searchParameters.infants = searchStore.passengers.infants
                // searchParameters.exactAirline = 'EY'
                string = 'tripType=multi'
                for (let i = 0; i < searchParameters.origin.length; i++) {
                  if (i === 2 && searchParameters.origin[2] === null) {
                    continue
                  }
                  string += `&origin[]=${searchParameters.origin[i].Code}&destination[]=${searchParameters.destination[i].Code}&originType[]=${searchParameters.origin[i].Type}&destinationType[]=${searchParameters.destination[i].Type}&departureDate[]=${searchParameters.departureDate[i]}`
                }
                string += `&classType=${searchParameters.classType}&adults=${searchParameters.adults}&children=${searchParameters.children}&infants=${searchParameters.infants}`
                string += `&directFlights=${this.directFlights ? 1 : 0}`
                string += `&exactAirline=${searchParameters.exactAirline}`
                if (searchStore.preferredAirline) string += `&preferredAirline${searchStore.preferredAirline.code}`
                // console.log(string)
                this.request(string)
              } else {
                this.errorBar = true
              }
              break
            default:
              break
          }
        } else {
          this.snackbar = true
          this.color = 'error'
          this.text = 'Please choose departure date before the arrival date you chose'
          this.$emit('endLoad')
        }
      } else {
        this.snackbar = true
        this.color = 'error'
        this.text = 'Please choose departure date starting after today'
        this.$emit('endLoad')
      }
    },
    request (data) {
      this.loading = true
      this.$store.dispatch('removetFlightResults')
      this.$store.dispatch('setShowFlightResults', false)
      this.$store.dispatch('setDirectFlights', this.directFlights)
      this.$http.get(searchFlights(data), { headers: headersNoAuth() }).then(response => response.json()).then(response => {
        this.$emit('endLoad')
        // if (response.status === false) {
        //   this.warningBar = true
        //   this.loading = false
        // } else {
        this.$store.dispatch('setFlightsTimeOut', false)
        if (this.$store.state.flightsSearchTimeOutFunction !== null) this.$store.dispatch('clearFlightsSearchTimeoutFunction')
        if (this.$store.state.flightsTimeOutFunction !== null) this.$store.dispatch('clearFlightsTimeoutFunction')
        this.$store.dispatch('setFlightsSearchTimeoutFunction', setTimeout(() => {
          this.$store.dispatch('setFlightsTimeOut', true)
        }, 20 * 60 * 1000)
        )
        this.$store.dispatch('setFlightResults', response.data)
        this.loading = false
        localStorage.setItem('alternateSearchTerm', data)
        this.$store.dispatch('setShowFlightResults', true)
        this.$emit('scrollNow')
        this.$emit('addFlights')
        // }
      }, () => {
        this.loading = false
        this.$emit('endLoad')
        this.warningBar = true
      })
    }
  },
  created () {
    this.$store.state.flightType === '' ? this.flightType.value = 'round' : this.flightType.value = this.$store.state.flightType
  }
}
</script>

<style scoped>
  .search {
    border-radius: 5px;
    padding-top: 5px;
  }
  .btn {
    transform: translateY(-15px);
  }

  .flight-types input[type=radio] {
    height: 20px;
    width: 20px;
    vertical-align: middle;
    /* accent-color: orange; */
    /* color: white; */
  }
  .cont{
  position: relative;
}
  .arrowsIcon{
  position: absolute;
  left: -10px;
  top:20px;
  padding: 1px;
  z-index: 2;
}
 .v-text-field--outlined >>> fieldset {
  border-color: #4859B8;
  border-width: 2px;
  border-radius: 10px;
}
</style>
